/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { environment, ModulesEnum as ProdModuleEnum } from '../../../environments/environment';

@Injectable()
export class EnvironmentGuard {
    constructor(
        private router: Router,
    ) {
    }

    /**
     * Can activate route.
     * @returns boolean
     */
    public canActivate(route: ActivatedRouteSnapshot) {
        const canAccess = this.canAccessModule(route);

        if (!canAccess) {
            this.router.navigateByUrl('login').then().catch();

            return false;
        }

        return canAccess;
    }

    /**
     * Check current module against url.
     * @route
     * @private
     */
    private canAccessModule(route: ActivatedRouteSnapshot): boolean {
        const paths = route.url.map(item => item.path);

        return (paths.includes('lb') && environment.module === ProdModuleEnum.LOADBALANCER) ||
            (paths.includes('cm') && environment.module === ProdModuleEnum.CENTRALISED_MANAGEMENT);
    }
}
